import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import LoadingDots from 'components/LoadingDots';
import { PERMISSION } from 'constants/logic';
import { schedulePropTypes } from 'constants/propTypes';
import { selectActiveVenue, selectUserHasPermission } from 'selectors/general';

import EmptyInsights from '../EmptyInsights';
import { ClassReservations, HistoricalUtilization } from '../Insights';
import { useScheduleInsights } from './ScheduleDetailV2.hooks';

const InsightsTabContent = ({ schedule }) => {
  const { currencyCode, directFillDataDisabled, isManualStudio } = useSelector(selectActiveVenue);
  const canViewRates = useSelector(state => selectUserHasPermission(state, PERMISSION.DISPLAY_RATE));
  const { data: insights, isError, isLoading } = useScheduleInsights(schedule.scheduleId);

  const noDirectFillData = isManualStudio || directFillDataDisabled;

  if (isError) {
    return <EmptyInsights />;
  }

  if (isLoading) {
    return <LoadingDots />;
  }

  return (
    <>
      <div className="yield-management__class-utilization-container">
        <ClassReservations noDirectFillData={noDirectFillData} schedule={schedule} />
      </div>
      <div className="yield-management__historical-utilization-container">
        <HistoricalUtilization
          schedule={schedule}
          insights={insights}
          currencyCode={currencyCode}
          noDirectFillData={noDirectFillData}
          canViewRates={canViewRates}
        />
      </div>
    </>
  );
};

InsightsTabContent.propTypes = {
  schedule: PropTypes.shape(schedulePropTypes),
};

export default InsightsTabContent;
